import _, { head, last } from 'lodash';
import { DateTime, Duration } from 'luxon';
import { CellType, CellTypeOption } from '..';

function isDate(value: string): boolean {
  const dateTime = DateTime.fromISO(value);
  return dateTime.isValid;
}

function isDuration(value: string): boolean {
  const duration = Duration.fromISO(value);
  return duration.isValid;
}

function isTimeSeries(value: Array<unknown>): boolean {
  const point = value.at(0) as Record<string, unknown>;
  return point ? 'timestamp' in point : false;
}

const determineCellType = (value: unknown): CellTypeOption => {
  if (typeof value === 'number') {
    return CellType.NUMBER;
  } else if (typeof value === 'string') {
    if (isDate(value)) {
      return CellType.TIMESTAMP;
    }
    if (isDuration(value)) {
      return CellType.DURATION;
    }
    return CellType.STRING;
  } else if (typeof value === 'boolean') {
    return CellType.BOOLEAN;
  } else if (Array.isArray(value)) {
    if (isTimeSeries(value)) {
      return CellType.TIMESERIES;
    }
    return CellType.ARRAY;
  } else if (typeof value === null) {
    return CellType.NULL;
  } else if (typeof value === 'object') {
    return CellType.OBJECT;
  } else {
    return CellType.UNKNOWN;
  }
};

/**
 * This method determines the data type for a column by taking a sample from the column data
 * @param key column id
 * @param data table data
 * @returns the data type for the column
 */
export const getColumnCellType = <TData>(key: string, data: TData[]): CellTypeOption => {
  return head(
    _(data)
      .sampleSize(data.length > 100 ? 100 : data.length)
      .map(key)
      .map(determineCellType)
      .countBy()
      .entries()
      .maxBy(last),
  ) as CellTypeOption;
};
